/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const productCardPriceSX: SxProps = {
	fontSize:globalBreak({mobile:14, desktop:18})
};

export const productCardListPriceSX = ({list}:{list:number}):SxProps => ({
	fontSize:16,
	fontWeight:list === 0 ? 'bold' : 400,
});

export const productCardOfferPriceSX = ({list, offer}:{list:number, offer:number}):SxProps => ({
	fontSize:18,
	color:list === 0 || list===offer? '#000' : 'text.offerPrice',
	fontWeight:'bold'
});